import React from 'react';
import { NumericFormat } from 'react-number-format';

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

export const NumberFormatInput = React.forwardRef<HTMLInputElement, CustomProps>(
  function NumberFormatInput(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        prefix="R$ "
        allowNegative={false}
        decimalScale={2}
        fixedDecimalScale
        decimalSeparator={','}
        thousandSeparator={'.'}
      />
    );
  },
);
